module.exports = __webpack_public_path__ + "img/selected7-min.ef84ab45.png";